<template>
    <v-sheet elevation="1" rounded height="80vh" class="pa-2" style="width: 8cm; margin: auto; height: 100%;">
        <div class="botones">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="green" icon @click="generarPDF()" v-bind="attrs" v-on="on">
                        <v-icon dark>
                            mdi mdi-printer
                        </v-icon>
                    </v-btn>
                </template>
                <span>Imprimir</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="red" icon @click="$router.go(-1)" v-bind="attrs" v-on="on">
                        <v-icon dark>
                            mdi mdi-close-circle-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>Cerrar</span>
            </v-tooltip>
            
        </div>
        <div id="printarea" style="width: 8cm; height: auto;">
            <div class="header">
                <h1 class="center">{{ print.idestablecimiento.nombrecomercial }}</h1>
                <p class="center"><strong>{{ print.idestablecimiento.propietario }}</strong></p>
                <p class="center">Nit: {{ parseInt(print.idestablecimiento.nit) }}</p>
                <p class="center">{{ `${print.idestablecimiento.direccion} ${print.idestablecimiento.municipio}
                    ${print.idestablecimiento.departamento}` }}</p>
                <p class="center">Teléfono: {{print.idestablecimiento.telefono}}</p>
                <h2>{{print.documento}}</h2>
                <p>Número: {{print.numero}}</p>
                <p>Serie: {{print.serie}}</p>
                <p>Fecha: {{ print.fecha | formatdate}}</p>
                <p v-if="print.autorizacion.length>3">Autorización: {{print.autorizacion}}</p>
                <hr>
                <p>Cliente: {{print.cliente}}</p>
                <p>Nit: {{print.idpersona.nit}}</p>
                <p>Dirección: {{print.idpersona.direccion}}</p>
                <hr>

                <!-- Inicio tabla productos -->
                <table>
                    <thead>
                        <tr>
                            <td>Cant.</td>
                            <td>Descripción</td>
                            <td>Total</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in print.productos" :key="index">
                            <td>{{ item.cantidad }}</td>
                            <td>{{ item.nombre }}. {{ item.precioventa| currency }}c/u</td>
                            <td>{{ item.total | currency }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2">Subtotal</td>
                            <td>{{ subtotal| currency }}</td>
                        </tr>
                        <tr v-if="totaldescuento>0">
                            <td colspan="2">Descuento</td>
                            <td>{{ totaldescuento| currency }}</td>
                        </tr>
                        <tr>
                            <td colspan="2">IVA</td>
                            <td>{{totaliva| currency }}</td>
                        </tr>
                        <tr class="bold">
                            <td colspan="2">TOTAL A PAGAR</td>
                            <td>{{totalfactura| currency }}</td>
                        </tr>
                    </tfoot>
                </table>
                <hr>
                <div v-if="print.documento == 'Factura Electrónica'">
                    <div v-if="print.idestablecimiento.codregimen == 'GEN'">
                        <strong class="regimen">* SUJETO A PAGOS TRIMESTRALES ISR</strong>
                        <p>Certificador: Digifact Servicios, S.A. NIT: 7745482-0</p>
                    </div>
                    <div v-else>
                        <strong class="regimen"> FACTURA DE PEQUEÑO CONTRIBUYENTE</strong>
                        <p>*No genera derecho a crédito fiscal</p>
                        <p>Certificador: Digifact Servicios, S.A. NIT: 7745482-0</p>
                    </div>
                </div>
                <p class="label_gracias">¡Gracias por su compra!</p>
            </div>
        </div>
    </v-sheet>
</template>
<script>
import currency from "@/utils/currency.js";
import html2pdf from 'html2pdf.js';
import {mapGetters} from 'vuex'

export default {
    name: 'GenerarFactura',

    data: () => ({
        centimetro:0.027,
        totalfactura:0,
        totaldescuento:0,
        subtotal:0,
        totaliva:0,     
    }),
    computed:{
        ...mapGetters({
            print:"getDatatToPrint",         
        }),
        calcularAlto(){
            return document.getElementById("printarea").offsetHeight * this.centimetro;
        }
    },
    async created() {
        this.calcularTotales()
        this.calculoIVA()
    },
    methods: {     
        calcularTotales(){
            
            this.subtotal = currency(
                this.print.productos.reduce(
                    (total, current) =>
                        total +
                        (current.cantidad * current.precioventa),
                    0
                )
            );

            this.totaldescuento = currency(
                this.print.productos.reduce((total, current) =>
                    total += parseFloat(current.descuento),0
                )
            );

            this.totalfactura = currency(this.subtotal - this.totaldescuento);
        },
        calculoIVA(){
            const regimen = this.print.idestablecimiento.codregimen
            if(regimen=='GEN') this.totaliva = currency( (this.totalfactura/1.12) * 0.12)
            if(regimen=='PEQ') this.totaliva = currency( this.totalfactura * 0.05)
        },
        generarPDF() {
            const element = document.getElementById('printarea');
            var opt = {
                margin: [0.2, 0, 0.1 ,0], // [top, left, bottom, right]
                filename: 'myfile.pdf',
                image: { type: 'jpeg', quality: 0.99 },
                html2canvas: { scale: 3 },
                pagebreak: { avoid: "tr", mode: "css", before: "#nextpage1"},
                jsPDF: { unit: 'cm', format: [this.calcularAlto,8], orientation: 'portrait' }
                //jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            };

            html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
                // pdf.autoPrint();
                window.open(pdf.output('bloburl'), '_blank');
            });
        }
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.botones{
    text-align: right;
    margin-right: 5px;
}

#printarea{
    padding: 25px;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-style: normal;
    box-sizing: border-box;
    page-break-inside: avoid;
    font-size: 13px;
}
#printarea p{
    font-weight: normal;
    font-size: 1em;
}

hr{
    margin-block-start:5px;
    margin-block-end: 5px;
}
 h1, h2, h3, h4{
    text-transform: uppercase;
    font-weight: 500;
    margin-block-start:0px;
    margin-block-end: 0px;
 }
 h1{
    text-align: center;
    font-size: 1.5em;
    font-weight: bold;
 }

 h2{
    padding-top: 10px;
    text-align: center;
    font-size: 1em;
    font-weight: bold;
 }

 .center{
    text-align: center;
 }

 .bold{
    font-weight: bold;
 }

p{
    
    font-size: 12px;
    margin-block-start:0px;
    margin-block-end: 0px;
}

table{
    width: 100%;
}

table thead tr{
    text-align: center;
    font-weight: bold;
}

.regimen{
font-size: 0.9em;
}

.label_gracias{
    margin-top: 0.5em;
    font-weight: bold;
    font-style: italic;
    text-align: center;
}
</style>